import { useEffect, useState } from "react";
import {
  PortalProviderContext,
  PortalProviderProps,
} from "./PortalProviderContext";

export const PortalProvider = (props: PortalProviderProps) => {
  const { root: rootProp, children } = props;
  const [root, setRoot] = useState(rootProp);

  useEffect(() => {
    setRoot(rootProp);
  }, [rootProp]);

  return (
    <PortalProviderContext.Provider value={{ root }}>
      {children}
    </PortalProviderContext.Provider>
  );
};
